import { IDyatel, IStatuses } from '@dto/user/userInfo.dto'

export enum BaseColumn {
  FULL_NAME = 'fullName',
  CITY = 'city',
  REGION = 'area',
  ADDRESS = 'address',
  AGE = 'age',
  PHONE = 'phone',
  TIME_ZONE = 'timeZone',
  ADDITION_FIELD_1 = 'additionField1',
  ADDITION_FIELD_2 = 'additionField2',
  ADDITION_FIELD_3 = 'additionField3',
  ADDITION_INFO = 'additionInfo',
}

export enum BaseDefaultStatusesColumn {
  SMARTERME = 'smarterme',
  NOMONEY = 'nomoney',
  SLIV = 'sliv',
  RETRIEVED = 'retrieved',
  UNDERCALL = 'underCall',
  REMOVE = 'remove',
  UNDEFINED = 'undefined',
  ALL_DAY = 'dayCalls',

  UNDERCALL_D = 'under_call',
  ALL_DAY_D = 'daycalls',

  REMAINDER = 'remainder',
  PENDING = 'pending',
  IN_WORK = 'inwork',
  RECALL = 'recall',
  TRANSMIT = 'transmit',
}

export type Statuses = keyof IStatuses

export type StatusesD = keyof IDyatel

export const statusesList: Statuses[] = [
  'dayCalls',
  'smarterme',
  'nomoney',
  'sliv',
  'retrieved',
  'underCall',
  'remove',
  'undefined',
]

export const statusesListD: StatusesD[] = [
  'daycalls',
  'smarterme',
  'nomoney',
  'sliv',
  'retrieved',
  'under_call',
  'remove',
  'undefined',
]
